import React, { useEffect, useRef, useState } from 'react';

type TextColumnProps = {
  value?: string
  onChange: ( value?: string ) => void
};

function TextColumn( { value, onChange }:TextColumnProps ) {
  const [editing, setEditing] = useState( false );
  const [draft, setDraft] = useState( value );
  const ref = useRef<HTMLInputElement>( null );

  useEffect( () => { if ( editing ) ref.current?.focus(); }, [editing] );
  useEffect( () => { if ( !editing ) setDraft( value ); }, [value, editing] );

  const commit = () => {
    // setDraft( value )
    onChange( draft?.trim() );
    setEditing( false );
  };
  const cancel = () => { setDraft( value ); setEditing( false ); };

  return (
    editing ? (
      <input
        ref={ref}
        className="form-control form-control-sm table-input"
        value={draft}
        onChange={( e ) => setDraft( e.target.value )}
        onBlur={commit}
        onKeyDown={( e ) => {
          if ( e.key === 'Enter' ) { e.preventDefault(); commit(); }
          if ( e.key === 'Escape' ) { e.preventDefault(); cancel(); }
        }}
      />
    ) : (
      <span
        onClick={() => setEditing( true )}
      >
        {value || '-'}
      </span>
    )
  );
}

export default TextColumn;
